export enum OperationStatus {
  New,
  Processing,
  Expired,
  Finished,
  Canceled
}
